import Vuex from "vuex";
import Vue from "vue";
// import menuNamesForId from "./menuNamesForId.json"
// import menuNamesForId from "../../public/menuNamesForProd.json";

import action from "./action";
import mutation from "./mutation";

Vue.use(Vuex);

const store = new Vuex.Store({
  strict: true,
  state: {
    userId: null,
    userName: null,
    userRole: null,
    url: null,
    loginError : '',
    password: null,
    showDisplay: false,
    items:[],
    isItemState: false,
    isLoginLoader:false,
    logoutModal:false,
    serverDate: "",
    menus:[],
    userAuthenticated: false,
     authInitialized: false,
     isAuthRefreshed: false,
     menu: {},

  },
  
  mutations: {
    ...mutation,
  },
  actions: {
    ...action,
  },
  
  getters: {
    url(state) {
      return state.url;
    },
    getCurrentAuthState(state){
      return state.isAuthRefreshed
    },

    getUserData(state){
      return {
        userId: state.userId,
        userName: state.userName,
      }
    },

  },
});

export default store;
